export const getRandomId = () => String(Math.floor(Math.random() * 1000000))